/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "8bcc1cc413c2606fd3ee18bff9214b87f1b714f6";
